export const classes = {
  deleteIcon: 'text-red-2',
};
